import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangelogComponent } from './changelog/changelog.component';

const routes: Routes = [
  {
    path: '',
    title: 'Novedades',
    component: ChangelogComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChangelogRoutingModule {}
